<div id="transaction-details-section">
    <span id="subtitle">Standing authorization details</span>
    <a *ngIf="(createRequestStep$ | async) === 'review' && !isInrFromTable && !isQCDCheckSloa" id="edit-link" 
        class="no-print"  (click)="onEditClicked()" data-testid="standingAuthCheckDetails_editLink">Edit</a>
    <mm-label-group id="standingAuthCheckDetails_transactionType" data-testid="standingAuthCheckDetails_transactionType"
        [title]="labels.transactionType" [data]="transactionType"></mm-label-group>

    <div class="row" id="standingAuthCheckDetails_payeeRow">
        <div class="column">
            <mm-label-group id="standingAuthCheckDetails_payee" data-testid="standingAuthCheckDetails_payee"
                [title]="labels.payee" [data]="payeeType">
            </mm-label-group>
        </div>
        <div class="column">
            <mm-label-group id="standingAuthCheckDetails_payeeName" data-testid="standingAuthCheckDetails_payeeName"
                [title]="labels.payeeName" [multilineData]="payeeName">
            </mm-label-group>
        </div>
    </div>

    <div class="row">
        <mm-label-group id="standingAuthCheckDetails_deliveryAddress"
            data-testid="standingAuthCheckDetails_deliveryAddress" [title]="labels.deliveryAddress"
            [multilineData]="deliveryAddress"></mm-label-group>
    </div>

    <!-- TWE FIELDS -->
    <div *ngIf="iraAccount">
        <div class="row">
            <div class="column">
                <mm-label-group id="standingAuthCheckDetails_federalTax"
                    data-testid="standingAuthCheckDetails_federalTax" [title]="labels.federalTax"
                    [data]="fedTaxPercent"></mm-label-group>
            </div>
        </div>
        <div class="row">
            <div class="column">
                <mm-label-group id="standingAuthCheckDetails_stateTax" data-testid="standingAuthCheckDetails_stateTax"
                    [title]="saStateTaxLabel" [data]="stateTaxPercent"></mm-label-group>
            </div>
        </div>
        <div class="row">
            <div class="column">
                <mm-label-group id="standingAuthCheckDetails_distributionReason"
                    data-testid="standingAuthCheckDetails_distributionReason" [title]="labels.distributionReason"
                    [data]="distributionReason"></mm-label-group>
            </div>
        </div>
    </div>

    <div class="row">
        <mm-label-group *ngIf="displayReason" id="standingAuthCheckDetails_checkReason"
            data-testid="standingAuthCheckDetails_checkReason" [title]="labels.checkReason"
            [data]="selectReason(checkReason) | sentenceCase"></mm-label-group>
    </div>

    <div class="row">
        <mm-label-group *ngIf="displayMemo" id="standingAuthCheckDetails_memo"
            data-testid="standingAuthCheckDetails_memo" [title]="labels.memo"
            [data]="standingAuthDetails.checkMemo!"></mm-label-group>
    </div>

    <div class="row">
        <mm-label-group *ngIf="displayNickname" id="standingAuthCheckDetails_authorizationNickname"
            data-testid="standingAuthCheckDetails_authorizationNickname" [title]="labels.authorizationNickname"
            [data]="standingAuthDetails.authorizationNickname!"></mm-label-group>
    </div>
</div>
<sdps-divider variation="secondary"></sdps-divider>
